module.exports = __webpack_public_path__ + "33b4b4571a7919961f84da040d072a3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/assets/images/AnchorLogo.png
// module id = 424
// module chunks = 0